<header class="provider-appointment-widget__header">
  <h3 class="provider-appointment-widget__header-text"><%= title %></h3>
</header>

<section class="provider-appointment-widget-section location"></section>

<section class="provider-appointment-widget-section patient-type"></section>

<section class="provider-appointment-widget-section slots"></section>
